export const catalog = {
  version: "1.0.0",
  themes: [
    {
      id: "ea_visie",
      shortName: "Visie",
      icon: "🧭",
      title: "1. EA-visie",
      levels: {
        level1: {
          id: "level1",
          tagline: "EA-visie en principes zijn beschreven en bestuurlijk afgestemd.",
          kenmerken: [
            "Korte EA-visie (max. 2 A4) in lijn met strategie en ICT Visie 2025.",
            "EA benoemd als strategisch hulpmiddel voor bestuurlijke vraagstukken.",
            "Set van 5–10 kernarchitectuurprincipes (D1) is vastgesteld.",
          ],
          acties: [
            { id: "ea_visie.level1.actie_01", text: "Concept EA-visie opstellen en afstemmen met CIO/directie." },
            { id: "ea_visie.level1.actie_02", text: "Kernprincipes (D1) formuleren en bestuurlijk laten vaststellen." },
            { id: "ea_visie.level1.actie_03", text: "EA-visie en principes publiceren (EA-portaal / intranet)." },
          ],
          dod: [
            "EA-visie is formeel vastgesteld en intern beschikbaar.",
            "Minimaal 5–10 EA-principes (D1) zijn bekrachtigd.",
            "Visiedocument beschrijft expliciet hoe EA bestuurlijke vraagstukken vertaalt naar bedrijfskundige oplossingsrichtingen.",
          ],
        },
        level2: {
          id: "level2",
          tagline: "EA-visie stuurt aantoonbaar programma’s en projecten.",
          kenmerken: [
            "EA-visie wordt actief gebruikt bij portfolio- en programmabesluiten.",
            "Architectuurprincipes worden expliciet aangehaald in besluitstukken.",
            "EA-visie wordt periodiek herijkt op basis van strategie en programmasturing.",
          ],
          acties: [
            { id: "ea_visie.level2.actie_01", text: "EA-visie verankeren in formats voor MIP-/portfolio- en programmanota’s." },
            { id: "ea_visie.level2.actie_02", text: "Besluitstukken standaard laten verwijzen naar relevante EA-principes." },
            { id: "ea_visie.level2.actie_03", text: "Jaarlijkse review van de EA-visie plannen in Stuurgroep ICT." },
          ],
          dod: [
            "≥80% van besluitstukken verwijst naar EA-visie en/of principes.",
            "Jaarlijkse herijking van EA-visie is vast onderdeel van de planning & control-cyclus.",
            "Programmamanagers kunnen benoemen hoe EA-visie hun programma’s stuurt.",
          ],
        },
      },
    },

    {
      id: "ea_processen",
      shortName: "Processen",
      icon: "⚙️",
      title: "2. EA-processen",
      levels: {
        level1: {
          id: "level1",
          tagline: "Proces “werken onder architectuur” is op papier uitgewerkt.",
          kenmerken: [
            "Processchema voor EA-intake, -toets en -besluit is beschreven.",
            "EA heeft een benoemde plek in PITS/portfolio-/MIP-proces.",
            "RACI voor EA-rollen is vastgelegd.",
          ],
          acties: [
            { id: "ea_processen.level1.actie_01", text: "Proces “werken onder architectuur” samen met PMO/PITS ontwerpen." },
            { id: "ea_processen.level1.actie_02", text: "EA-intakeformulier of -checklist opstellen en beschikbaar maken." },
            { id: "ea_processen.level1.actie_03", text: "RACI voor EA opnemen in procesdocumentatie portfolio/projecten." },
          ],
          dod: [
            "Proces “werken onder architectuur” is vastgesteld (intake → toets → besluit).",
            "EA-intakeformulier/-checklist is gepubliceerd en bekend.",
            "RACI met EA-rollen is onderdeel van de officiële procesbeschrijving.",
          ],
        },
        level2: {
          id: "level2",
          tagline: "EA-intake en -toets zijn een normale stap in besluitvorming.",
          kenmerken: [
            "EA-processen worden in de meeste projecten daadwerkelijk gevolgd.",
            "EA is structureel agendapunt in portfolio-/PITS-overleggen.",
            "Gate-dekking en doorlooptijd van EA-toetsen worden gemeten.",
          ],
          acties: [
            { id: "ea_processen.level2.actie_01", text: "EA-intake verplicht stellen in project-/MIP-formats." },
            { id: "ea_processen.level2.actie_02", text: "EA-gate opnemen als formeel besluitmoment in portfolio-/PITS-overzicht." },
            { id: "ea_processen.level2.actie_03", text: "Maandelijkse rapportage van gate-dekking en doorlooptijd naar Stuurgroep ICT organiseren." },
          ],
          dod: [
            "≥80% van nieuwe initiatieven doorloopt een EA-intake vóór besluitvorming.",
            "EA is vast agendapunt in portfolio-/PITS-overleggen.",
            "KPI’s over gate-dekking en doorlooptijd worden minstens elk kwartaal besproken.",
          ],
        },
      },
    },

    {
      id: "ea_producten",
      shortName: "Producten",
      icon: "📌",
      title: "3. EA-producten",
      levels: {
        level1: {
          id: "level1",
          tagline: "Basis EA-producten zijn aanwezig en benoemd.",
          kenmerken: [
            "Een EA-productencatalogus beschrijft welke producten worden gemaakt.",
            "D1-principes en een eerste D2-toetsingsmatrix zijn vastgesteld.",
            "Top 10–20 bedrijfsfuncties zijn gemodelleerd en gekoppeld aan systemen.",
          ],
          acties: [
            { id: "ea_producten.level1.actie_01", text: "EA-productencatalogus opstellen (per product: doel, gebruiker, gebruiksmoment)." },
            { id: "ea_producten.level1.actie_02", text: "Top-bedrijfsfuncties modelleren en koppelen aan informatie en systemen." },
            { id: "ea_producten.level1.actie_03", text: "Minstens één doelarchitectuurplaat maken voor een prioritaire keten." },
          ],
          dod: [
            "EA-productencatalogus is vastgesteld (incl. D1, D2, D3, doelarchitecturen, roadmaps).",
            "Minstens 10–20 kern-bedrijfsfuncties zijn gemodelleerd en opgenomen in de repository.",
            "Minstens één doelarchitectuur is gebruikt in een Stuurgroep-/MT-besluit.",
          ],
        },
        level2: {
          id: "level2",
          tagline: "EA-producten sturen actief programma’s, projecten en keuzes.",
          kenmerken: [
            "Voor alle strategische speerpunten is een actuele doelarchitectuur beschikbaar.",
            "Roadmaps zijn afgestemd met programmasturing en beïnvloeden prioritering.",
            "D2-toetsingsmatrix wordt gebruikt voor technologie- en vendor-keuzes.",
          ],
          acties: [
            { id: "ea_producten.level2.actie_01", text: "Doelarchitecturen opstellen voor alle prioritaire ketens (data, backbone, AM, security)." },
            { id: "ea_producten.level2.actie_02", text: "Roadmaps per keten afstemmen met portfolio-/programmamanagers." },
            { id: "ea_producten.level2.actie_03", text: "D2-toetsingsmatrix actief toepassen bij nieuwe platform- en leverancierskeuzes." },
          ],
          dod: [
            "Voor elk strategisch speerpunt is een actuele doelarchitectuur beschikbaar en gebruikt.",
            "EA-roadmaps worden gebruikt bij programmasturing en investeringsbesluiten.",
            "D2-toetsingsmatrix is aantoonbaar toegepast in recente beslissingen.",
          ],
        },
      },
    },

    {
      id: "ea_mensen",
      shortName: "Mensen",
      icon: "👥",
      title: "4. EA-mensen",
      levels: {
        level1: {
          id: "level1",
          tagline: "Rol en positie van architecten zijn beschreven.",
          kenmerken: [
            "Rolprofielen voor (lead) architecten zijn vastgelegd.",
            "Stakeholdermap laat zien met wie EA structureel samenwerkt.",
            "Er is een eerste training/workshop over de EA-rol gehouden.",
          ],
          acties: [
            { id: "ea_mensen.level1.actie_01", text: "Rolprofielen voor EA opstellen en afstemmen met directie/HR." },
            { id: "ea_mensen.level1.actie_02", text: "Belangrijkste stakeholders (MT, Stuurgroep ICT, PITS, CISO, domeineigenaren) in kaart brengen." },
            { id: "ea_mensen.level1.actie_03", text: "Introductietraining organiseren over de EA-rol voor architecten en key stakeholders." },
          ],
          dod: [
            "Rolprofielen voor EA zijn vastgesteld en gecommuniceerd.",
            "Een actuele stakeholdermap met EA-relevante rollen is beschikbaar.",
            "Minstens één training/workshop over de EA-rol is uitgevoerd.",
          ],
        },
        level2: {
          id: "level2",
          tagline: "Architecten opereren zichtbaar als strategische gesprekspartner.",
          kenmerken: [
            "Architecten zijn structureel aanwezig bij relevante MT-/Stuurgroep ICT-onderwerpen.",
            "EA-adviezen en scenario’s worden expliciet gevraagd en meegewogen.",
            "Architecten worden gecoacht on-the-job en hebben een ontwikkelplan.",
          ],
          acties: [
            { id: "ea_mensen.level2.actie_01", text: "Architecten structureel uitnodigen voor relevante Stuurgroep ICT- en MT-vergaderingen." },
            { id: "ea_mensen.level2.actie_02", text: "1-op-1 coaching organiseren voor architecten rondom concrete portfolio-/projectcasussen." },
            { id: "ea_mensen.level2.actie_03", text: "Jaarlijkse evaluatie van de EA-rol opnemen in HR-/functioneringsgesprekken." },
          ],
          dod: [
            "Architecten nemen deel aan ≥80% van de relevante IV-/ICT-besprekingen.",
            "EA-adviezen worden expliciet genoemd in besluitstukken.",
            "Alle EA-rolhouders hebben een actueel ontwikkelplan en ontvangen jaarlijkse coaching/feedback.",
          ],
        },
      },
    },

    {
      id: "ea_middelen",
      shortName: "Middelen",
      icon: "🧰",
      title: "5. EA-middelen (tooling & info)",
      levels: {
        level1: {
          id: "level1",
          tagline: "EA-tooling, portaal en templates zijn ingericht.",
          kenmerken: [
            "EA-tool (bijv. Archi) is gekozen en basisrepository is opgezet.",
            "EA-startpagina met visie, principes en kernmodellen is beschikbaar.",
            "Templates voor EA-documenten en PSD met EA-paragraaf zijn gedefinieerd.",
          ],
          acties: [
            { id: "ea_middelen.level1.actie_01", text: "Repositorystructuur opzetten (domeinen, functies, systemen, views)." },
            { id: "ea_middelen.level1.actie_02", text: "EA-portaal inrichten (visie, principes, modellen, templates)." },
            { id: "ea_middelen.level1.actie_03", text: "EA-templates (principes, architectuurnotitie, toetsrapport, PSD) opstellen en delen." },
          ],
          dod: [
            "EA-repository is operationeel met eerste modellen.",
            "EA-portaal is live met visie, principes en minstens één view.",
            "Templates voor EA-documenten en PSD met EA-paragraaf zijn vastgesteld.",
          ],
        },
        level2: {
          id: "level2",
          tagline: "Repository en templates zijn vanzelfsprekend onderdeel van het werk.",
          kenmerken: [
            "Architecten gebruiken de repository actief voor analyses en besluitvoorbereiding.",
            "Projectleiders gebruiken standaard EA-templates in PSD/MIP.",
            "EA-portaal wordt structureel geraadpleegd bij nieuwe initiatieven.",
          ],
          acties: [
            { id: "ea_middelen.level2.actie_01", text: "Architecten trainen in uniform gebruik van EA-tool/repository." },
            { id: "ea_middelen.level2.actie_02", text: "EA-views verplicht opnemen in besluitvormingssjablonen (Stuurgroep ICT/MT)." },
            { id: "ea_middelen.level2.actie_03", text: "Gebruik van EA-portaal monitoren en content verbeteren op basis van feedback." },
          ],
          dod: [
            "Minstens enkele grote besluiten per jaar worden onderbouwd met views uit de repository.",
            "≥80% van PSD’s bevat een ingevulde EA-paragraaf op basis van templates.",
            "Repository heeft dekking over alle strategische speerpunten (data, backbone, AM, security).",
          ],
        },
      },
    },

    {
      id: "ea_governance",
      shortName: "Governance",
      icon: "🏛️",
      title: "6. EA-besturing (governance)",
      levels: {
        level1: {
          id: "level1",
          tagline: "Architectuur-governance is ontworpen en beschreven.",
          kenmerken: [
            "Governanceplaat positioneert Architectuurboard ↔ Stuurgroep ICT ↔ domeinen/PITS.",
            "Charter Architectuurboard (doel, scope, mandaat, werkwijze) is opgesteld.",
            "Mandaat voor kaders en afwijkingen is beschreven.",
          ],
          acties: [
            { id: "ea_governance.level1.actie_01", text: "Governanceplaat samen met bestuur/Stuurgroep ICT tekenen en laten bekrachtigen." },
            { id: "ea_governance.level1.actie_02", text: "Charter voor de Architectuurboard opstellen en afstemmen." },
            { id: "ea_governance.level1.actie_03", text: "Eenvoudig “comply or explain”-logboek inrichten voor architectuurafwijkingen." },
          ],
          dod: [
            "Governanceplaat en charter Architectuurboard zijn formeel vastgesteld.",
            "Mandaten voor het vaststellen van D1/D2 en voor afwijkingen zijn vastgelegd.",
            "Basis “comply or explain”-log is operationeel.",
          ],
        },
        level2: {
          id: "level2",
          tagline: "Governance wordt zichtbaar toegepast in besluiten.",
          kenmerken: [
            "Architectuurboard vergadert regelmatig met concrete EA-dossiers.",
            "Afwijkingen op architectuurkaders worden vastgelegd en opgevolgd.",
            "EA-KPI’s worden periodiek gerapporteerd aan Stuurgroep ICT/bestuur.",
          ],
          acties: [
            { id: "ea_governance.level2.actie_01", text: "Architectuurboard structureel plannen en voorzien van agenda met dossiers." },
            { id: "ea_governance.level2.actie_02", text: "Systematisch vastleggen van besluiten en afwijkingen in het logboek." },
            { id: "ea_governance.level2.actie_03", text: "EA-KPI’s (gate-dekking, conformiteit, repository-dekking) definiëren en rapporteren." },
          ],
          dod: [
            "Architectuurboard komt regelmatig bijeen met relevante dossiers.",
            "Alle afwijkingen op D1/D2 zijn vastgelegd met voorwaarden en einddatum.",
            "EA-KPI’s worden minimaal twee keer per jaar aan Stuurgroep ICT gerapporteerd.",
          ],
        },
      },
    },

    {
      id: "ea_methode",
      shortName: "Methode",
      icon: "📈",
      title: "7. EA-methode",
      levels: {
        level1: {
          id: "level1",
          tagline: "EA-spoorboekje is beschreven en gedeeld.",
          kenmerken: [
            "EA-methode (bijv. Novius/DYA-light) is gekozen en beschreven (1–2 A4).",
            "Stappen van bestuurlijke vraag → analyse → ontwerp → toets → besluit → borging zijn helder.",
            "Methode verwijst naar EA-producten en governance (intake, board).",
          ],
          acties: [
            { id: "ea_methode.level1.actie_01", text: "EA-methode/spoorboekje opstellen en afstemmen met architecten/PMO." },
            { id: "ea_methode.level1.actie_02", text: "PSD-sjabloon uitbreiden met verplichte EA-paragraaf volgens de methode." },
            { id: "ea_methode.level1.actie_03", text: "EA-methode publiceren op het EA-portaal." },
          ],
          dod: [
            "EA-methode v1.0 (1–2 A4) is vastgesteld en gedeeld.",
            "PSD bevat een verplichte EA-paragraaf die naar de EA-methode verwijst.",
            "Architecten kennen de stappen van de EA-methode.",
          ],
        },
        level2: {
          id: "level2",
          tagline: "Projecten en programma’s volgen herkenbaar de EA-methode.",
          kenmerken: [
            "Meerdere projecten doorlopen aantoonbaar alle EA-stappen.",
            "EA-methode is geïntegreerd in project-/programmamanagementmethodiek.",
            "Ervaringen worden gebruikt om de methode “lean” te houden.",
          ],
          acties: [
            { id: "ea_methode.level2.actie_01", text: "Pilotprojecten selecteren die de EA-methode volledig toepassen." },
            { id: "ea_methode.level2.actie_02", text: "Evaluaties uitvoeren en de methode aanpassen op basis van feedback." },
            { id: "ea_methode.level2.actie_03", text: "EA-methode opnemen in officiële project- en programmastandaarden." },
          ],
          dod: [
            "Minstens enkele projecten hebben de volledige EA-methode doorlopen.",
            "Project-/programmamanagement verwijst expliciet naar de EA-methode in hun werkwijzen.",
            "Jaarlijkse update van de EA-methode op basis van praktijkervaringen is geborgd.",
          ],
        },
      },
    },
  ],
};